import { faObjectGroup, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { Alert, Button, Form, FormGroup, Modal } from "react-bootstrap";
import { CheckLg, DashCircle, Exclamation, ExclamationTriangleFill } from "react-bootstrap-icons";
import { setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import { mergeDocuments } from "../store/api/DocumentsAPI";
import { useDispatch } from "react-redux";

export default function ModalMergeDocuments(props) {
    const { popData, setPopData } = props;
    const { show } = popData;
    const dispatch = useDispatch();
    const inputNumber = useRef();
    const inputMergeType = useRef();
    const [mergeError, setMergeError] = useState(null);
    const [isPending, setPending] = useState(false);
    function close() {
        setPending(false);
        setPopData({ show: false });
        setMergeError(null);
    }
function merge ()
{
    setMergeError(null);
    if(inputMergeType.current.value  === "")
    {
        setMergeError("نوع ادغام انتخاب نشده است.");
        return;
    }
    if(inputNumber.current.value?.toString() === "")
    {
        setMergeError("شماره آغازین وارد نشده است.");
        return;
    }
    const mergeType = inputMergeType.current.value?.toString() === "1" ?"ادغام روزانه اسناد":"ادغام 15 روزه اسناد";
    const onMerge =(res)=>{
        if(res.Error)
        {
            setMergeError(res.Error);
        }
        else if (res === "PENDING")
        {
            setPending(true);
        }
        else{
            setPending(false);
            close();
            setErrorDialog(dispatch, "success",mergeType);
        }
    }
    dispatch(setDialog({
        status: 'show',
        arrayBtn: ['yes', 'no'],
        dialogTitle: mergeType,
        dialogText: 'آیا از ادغام اسناد مطمئن هستید؟',
        okOperation: ()=> mergeDocuments(inputNumber.current.value, inputMergeType.current.value, onMerge)
    }))
}
    return (
        <Modal show={show} onHide={() => { }} size="sm">
            <Modal.Header className="headerStyle">

                <span>
                    <FontAwesomeIcon icon={faObjectGroup} size="lg"/>&nbsp;
                    ادغام اسناد حسابداری
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {mergeError && <Alert variant="danger"><ExclamationTriangleFill size={23} color="orange"/>&nbsp;{mergeError}</Alert>}
                <FormGroup>
                    <label>شماره آغازین:</label>
                    <Form.Control type="number" ref={inputNumber} defaultValue={1}/>
                </FormGroup>
                <FormGroup>
                    <label>نحوه ادغام:</label>
                    <Form.Control as="select" ref={inputMergeType}>
                        <option value="">انتخاب کنید</option>
                        <option value={1}>ادغام روزانه</option>
                        <option value={15}>ادغام هر 15 روز</option>
                    </Form.Control>
                </FormGroup>
                <div className="mt-1">
                    <Button className="group-Btn" variant="success" disabled={isPending} onClick={merge}><CheckLg size={18}/>&nbsp; ادغام اسناد</Button>
                    <Button className="group-Btn" variant="danger" onClick={close}><DashCircle size={18}/>&nbsp;انصراف</Button>
                </div>
            </Modal.Body>
        </Modal>
    )

}